import React from 'react'
import { Form, Select } from 'util/ui'
import { propFunc } from 'util/functions'
import Link from 'redux-first-router-link'

import sharedStyles from '../../../sharedForm/styles.less'
import {
  NUMBER_OF_EMPLOYEES_OPTIONS,
  CUSTOMER_HELP_QUESTION_OPTIONS,
  INDUSTRY_OPTIONS,
} from '../../../sharedForm/constants'
import styles from './styles.less'

export default class CustomerInformationForm extends React.PureComponent {
  handleChange = (name, _, { value }) => {
    const { onChange } = this.props
    onChange(name, value, null, { validate: true })
  }

  render() {
    const { formFields, submitForm, canSave, saving, nextPage } = this.props
    return (
      <Form size="large" className={sharedStyles.form}>
        <Form.Field>
          <label htmlFor="numberOfEmployeesInput" className={styles.formLabel}>
            How many {app.t('agents')} do you expect to have in Groove?
          </label>
          <Select
            name="numberOfEmployeesInput"
            className="large"
            options={NUMBER_OF_EMPLOYEES_OPTIONS}
            value={formFields.numberOfEmployeesInput}
            placeholder="- Please select -"
            onChange={propFunc(this.handleChange, 'numberOfEmployeesInput')}
          />
        </Form.Field>
        <Form.Field>
          <label htmlFor="customHelpInput" className={styles.formLabel}>
            Do you currently use help desk software?
          </label>
          <Select
            name="customHelpInput"
            className="large"
            options={CUSTOMER_HELP_QUESTION_OPTIONS}
            value={formFields.customHelpInput}
            placeholder="- Please select -"
            onChange={propFunc(this.handleChange, 'customHelpInput')}
          />
        </Form.Field>
        <Form.Field>
          <label htmlFor="industryInput" className={styles.formLabel}>
            What type of business are you in?
          </label>
          <Select
            name="industryInput"
            className="large"
            options={INDUSTRY_OPTIONS}
            value={formFields.industryInput}
            placeholder="- Please select -"
            onChange={propFunc(this.handleChange, 'industryInput')}
          />
        </Form.Field>
        <Form.Field>
          <hr />
        </Form.Field>
        <Form.Button
          primary
          size="big"
          fluid
          disabled={!canSave}
          onClick={submitForm}
        >
          {!saving ? 'Next step' : 'One moment...'}
        </Form.Button>
        <Form.Field>
          <Link
            to={{
              type: nextPage,
            }}
            as="a"
            className={sharedStyles.skipStep}
          >
            Skip this step
          </Link>
        </Form.Field>
      </Form>
    )
  }
}
